// For removing fast production addon
$(document).ready(function() {
    $(document).on('click', '.text-link.text-link--accent', function(e) {
        if ($(this).attr('aria-label') == "Remove Fast Production") {
			 e.preventDefault();
            $('#fast-production').click();
        }
    });
   
});
 
    window.onload = function() {
      var myIcon = document.querySelector(".lg-next.lg-icon");
      myIcon.addEventListener("click", function() {
        console.log("Icon was clicked!");
      });
    }

$(document).ready(function() {
//   Set the Pantone color text filed readable only
    $(document).on('click', '#cl471da353-field-0', function() {
        if (document.getElementById('cl471da353-field-0') != null) {
            document.getElementById('cl471da353-field-0').readOnly = true;
        }
    });
    $(document).on('click', 'body', function() {
        if (document.getElementById('cl471da353-field-0') != null) {
            document.getElementById('cl471da353-field-0').readOnly = true;
        }
    });
   $(document).on('focus', '#cl471da353-field-0', function() {
        $("#myInput").focus();
    });
  
  //custom pantone field to check pantone validation
   if($("#product-pantone-color").length)
    {
 
    if($("#product-pantone-color").val() == "")
    {
      console.log("empty");
      $('.shopify-payment-button button[data-testid="Checkout-button"]').prop("disabled", true);
    }
      $('.shopify-payment-button button[data-testid="Checkout-button"]').click(function() {
//     alert("simple bhai");
});
 
      $(document).on('click', '.shopify-payment-button button[data-testid="Checkout-button"]', function() {
//       alert("wogkifn");
});
      $('body').on('click', '.shopify-payment-button button[data-testid="Checkout-button"]', function() {
  console.log("inbetween");
        console.log("in progress");
});
     
       $(document).on('change', '#product-pantone-color', function() {
           $(".product-pantone-color-error").addClass("hidden");
         if($("#product-pantone-color").val() == "")
    {
      $('button[data-testid="Checkout-button"]').prop("disabled", true);
    }else
    {
      $('button[data-testid="Checkout-button"]').prop("disabled", false);
    }
 
      });

    }  
//   cart page date picker
     var fp_obj=$("#date").flatpickr({
        enableTime: false,
        dateFormat: "m/d/Y",
        minDate: new Date().fp_incr(1),
        "disable": [
            function(date) {
                return (date.getDay() === 0 || date.getDay() === 6); // disable weekends
            }
        ],
        "locale": {
            "firstDayOfWeek": 1 // set start day of week to Monday
                },
       plugins: [
    ShortcutButtonsPlugin({
      button: {
        label: 'Clear',

      },
      onClick: (index, fp) => {
        fp.clear();
        fp.close();
      }
    })
  ]
    });
  
  let currentDate = (new Date()).toLocaleString(undefined, { 
    year: 'numeric',
    month: '2-digit',
    day: '2-digit',
     });

  var selectedDate=$('#date').val();
  if(currentDate >= selectedDate)
  {
    //selected date is behind the min possible date
	fp_obj.clear();
  }
// For showing messages for production time
    $('#date').on('change', function() {
        var startDate = new Date($('#orderDate').text());
     	
      /* Set order delivery date */
     /* if($(this).val()==''){
      jQuery.post('/cart/update.js', {
        attributes: { 'Order Date': '', 'In Hand Date': '' },
      });
    }*/
      if($(this).val()==''){
      jQuery.post('/cart/update.js', {
        attributes: { 'In Hand Date': '' },
      });
    }
    else{

      /*jQuery.post('/cart/update.js', {
        attributes: { 'Order Date': startDate.toLocaleDateString("en-US"),
                     'In Hand Date': $('#date').val()},
       
      });*/
      jQuery.post('/cart/update.js', {
        attributes: { 'In Hand Date': $('#date').val()},
       
      });
    }
// 	var headers = new Headers({ 'Content-Type': 'application/json' });
//       alert("now");

//     var request = {
//       method: 'POST',
//       headers: headers,
//       body: JSON.stringify({ updates: { {{ id }}: 1 }, attributes: { 'In Hand Date': startDate } })
//     };
//     fetch('/cart/update.js', request)
//     .then(function() {
//       location.href = '/cart';
//     });
		
      	console.log(startDate);
        var endDate = "";
        var noOfDaysToAdd = $('#productionDays').text();
        if ($('#fast-production').prop('checked') == true) {
            var noOfDaysToAdd = 1;
        }
        count = 0;
        while (count < noOfDaysToAdd) {
            endDate = new Date(startDate.setDate(startDate.getDate() + 1));
            if (endDate.getDay() != 0 && endDate.getDay() != 6) {
                count++;
            }
        }


        function getBusinessDateCount(startDate, endDate) {
            var elapsed, daysBeforeFirstSaturday, daysAfterLastSunday;
            var ifThen = function(a, b, c) {
                return a == b ? c : a;
            };

            elapsed = endDate - startDate;
            elapsed /= 86400000;

            daysBeforeFirstSunday = (7 - startDate.getDay()) % 7;
            daysAfterLastSunday = endDate.getDay();

            elapsed -= (daysBeforeFirstSunday + daysAfterLastSunday);
            elapsed = (elapsed / 7) * 5;
            elapsed += ifThen(daysBeforeFirstSunday - 1, -1, 0) + ifThen(daysAfterLastSunday, 6, 5);

            return Math.ceil(elapsed);
        }

        function resetAlertStyle() {
            $('.alert').removeClass('production-error');
        }

        var dateDiff = getBusinessDateCount(new Date(endDate), new Date($(this).val())) - 1;
        resetAlertStyle();

        if ($('#fast-production').length) {

            if (dateDiff <= 0 && $('#fast-production').prop('checked') == false) {
                if ($('.ACTS-TEMP').length == 1) {
                    $('.alert').text('Production time is 3 to 5 days, add "FAST TRACK PRODUCTION" for '+fast_prod_price+' to ship the next business day');
                	$('.alert').removeClass('hide');
                	$('#is-a-production').show();
                } else {
                  if($('#productionfast').length)
                  {
                    if($('#productionfast').text() != "false" || ($('.list-view-item__title>a').html().trim().includes('Oval') && $('.list-view-item__title>a').html().trim().includes('Tablecloth')) )
                    {
                      $('.alert').text('Production time is 3 to 5 days, add "FAST TRACK PRODUCTION" for '+fast_prod_price+' to ship the next business day');
             		  $('.alert').removeClass('hide');
               		  $('#is-a-production').show();
                    }
                    
                  }
                  else
                  {
                    $('.alert').text('Production time is 3 to 5 days, add "FAST TRACK PRODUCTION" for '+fast_prod_price+' to ship the next business day');
                 	$('.alert').removeClass('hide');
                    $('#is-a-production').show();
                  }
                }
                
//                 $("html, body").animate({
//                     scrollTop: 0
//                 }, "slow");
            }
            if (dateDiff < -4 && $('#fast-production').prop('checked') == false) {
                $('.alert').text('Please call us to assist you with your request at 800-937-1159');
                $('.alert').removeClass('hide');
                $('#is-a-production').hide();
//                 $("html, body").animate({
//                     scrollTop: 0
//                 }, "slow");
            }
            if (dateDiff <= 0 && $('#fast-production').prop('checked') == true) {
                $('.alert').text('Please call us to assist you with your request at 800-937-1159');
                $('#date').val('');
                $('.alert').removeClass('hide');
//                 $("html, body").animate({
//                     scrollTop: 0
//                 }, "slow");
                $('#is-a-production').hide();
            }
        } else {
          	console.log('i am here!');
            $('#is-a-production').hide();
            if (dateDiff <= 0 && noOfDaysToAdd > 1) {
              
                if ($('.list-view-item__title>a').html().trim().includes('Oval') && $('.list-view-item__title>a').html().trim().includes('Tablecloth')) {
                    $('.alert').text('Production time is 3 to 5 days, add "FAST TRACK PRODUCTION" for '+fast_prod_price+' to ship the next business day');
                    $('#is-a-production').show();

                } else {
                 let nonPrintedProducts=false;
                    $("span[class^='hidden tags']").each(function(i, obj) {
                   if(($(obj).html().includes("dep-Premier Table Linens") || $(obj).html().includes("dep-Outlet Store") ||  $(obj).html().includes("dep-Outlet Store")) && $(obj).html().includes("prod-day-") )
                    {
                      nonPrintedProducts=true;
                  
                     }
                    });
                  if(nonPrintedProducts == true)
                  {
                    $('.alert').text('Please call us at 800-937-1159 so we can help you with this rush order.');

                  }
                  else
                  {
                     $('.alert').text('Please choose less production time for your order or call us at 800-937-1159.').addClass('production-error');

                  }

                }
                $('.alert').removeClass('hide');
//                 $("html, body").animate({
//                     scrollTop: 0
//                 }, "slow");
            } else if (dateDiff <= 0 && noOfDaysToAdd == 1) {
                $('.alert').text('Please call us to assist you with your request at 800-937-1159.');
                //                               $('.alert').text('it is passed our cut off time, however, we will do everything possible to make it happen, please call us right away at 800-937-1159');

                $('.alert').removeClass('hide');
//                 $("html, body").animate({
//                     scrollTop: 0
//                 }, "slow");
            }
        }
        if (dateDiff > 0) {
          //if fast production is an option, don't hide it
            //$('#is-a-production').hide();
            $('.alert').text('Select shipping method that will arrive in ' + dateDiff + ' business days.');
            $('.alert').removeClass('hide')
//             $("html, body").animate({
//                 scrollTop: 0
//             }, "slow");
        }

    });
  
    //trigger date change event on page to make sure no old/incorrect date pass to the backend.
    $("#date").trigger("change");
});

// For custom quantity on product page
$('.quantity-button').on('click', function() {
    var value = $(this).attr('value');
    $('.quantity-button').removeClass('selected');
    $(this).addClass('selected');
    $('.custom_quantity').val(value);
});

// For changing the product image on color select 
$(document).on('click', '.once-image', function() {
    $('.gravizoomImg:nth(0)').attr('src', $(this).attr('src'));
    $('.rondell-item-image:nth(0)').attr('src', $(this).attr('src'));
    $('#lightgallery>li:nth(0)>a>img').attr('src', $(this).attr('src'));
    $('#lightgallery>li:nth(0)').attr('data-src', $(this).attr('src'));
    console.log($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused'));
    if ($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused') == false) {
        $(".rondell-item-crop:nth(0)").trigger("click");
    }
    var scroll_pos = (0);
    $('html, body').animate({
        scrollTop: (scroll_pos)
    }, '2000');
});
$(document).on('click', '.swatch-color', function() {
    $('.once-image:nth(0)').hide();
});
$(document).on('click', '.mw-option__swatch-image', function() {
    if ($(this).parent().closest('.mw-option__value').hasClass('.mw-option__value--selected') == false) {
        if ($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused') == false) {
            $(".rondell-item-crop:nth(0)").trigger("click");
        }
        //     $('.rondell-item-image:nth(0)').attr('data-mw-default-src',$('.rondell-item-image:nth(0)').attr('src'));
        $('.gravizoomImg:nth(0)').attr('src', $(this).attr('src').replace("?width=100&height=100", ""));
        $('#lightgallery>li:nth(0)>a>img').attr('src', $(this).attr('src').replace("?width=100&height=100", ""));
        $('#lightgallery>li:nth(0)').attr('data-src', $(this).attr('src').replace("?width=100&height=100", ""));
        //   $('.rondell-item:nth(0)').attr('href', $(this).attr('src').replace("width=100&height=100", "width=400&height=400"));
        //     $('.rondell-item-image.rondell-item-resizeable:nth(0)').attr('src', $(this).attr('src').replace("width=100&height=100", "width=400&height=400"));

    } else {
        if ($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused') == false) {
            $(".rondell-item-crop:nth(0)").trigger("click");
        }
        $('.gravizoomImg:nth(0)').attr('src', $('.rondell-item-image:nth(0)').attr('data-mw-default-src'));
        $('ul#lightgallery>li:nth(0)>a>img').attr('src', $('.rondell-item-image:nth(0)').attr('data-mw-default-src'));
        $('ul#lightgallery>li:nth(0)').attr('data-src', $('.rondell-item-image:nth(0)').attr('data-mw-default-src'));
        $('.rondell-item:nth(0)').attr('href', $('.rondell-item-image:nth(0)').attr('data-mw-default-src'));

    }
});
// Find the table cell with the word "each"
var cells = document.querySelectorAll("#wsaio-volume-discount--table td");
for (var i = 0; i < cells.length; i++) {
    var cell = cells[i];
    if (cell.textContent.indexOf("each") !== -1) {
        // Replace the content of the cell without the word "each"
        cell.textContent = cell.textContent.replace(" each", "");
    }
}


// For Adding the Data in product page product details table
$(document).ready(function() {
    setTimeout(() => {
        var tags = $('#tags').val();
        if ($('#tags').val() != undefined) {
            tags = tags.split(',');
            var size = "";
            var fab = "";
            var pat = "";
            var clr = '';
            var clf = '';
            var feat = '';
            var shp = '';
            var matrl = "";
            var cond = "";
            var chairtype = "";
            var categ = "";
            var serpentinemodel = "";
            var serpentinestyle = "";
            var CocktailTableStyle = "";
            var DrumCoverSize = "";
            var TrashCanCoverSize = "";
            var RunnerStyle = "";
            var BurlapStyle = "";
            var printstyle = "";
            var prodtime = "";
            var sailshp = "";
            var sailpoint = "";



            $.each(tags, function(key, value) {
                if (value.includes('prod') == false) {
                    if (value.includes('dep-')) {
                        value = value.replace("dep-", "")
                    }
                    if (value.includes('fab-')) {
                        value = value.replace("fab-", "");
                        fab = fab + ', ' + value;
                    }
                    if (value.includes('pat-')) {
                        value = value.replace("pat-", "");
                        pat = pat + ', ' + value;
                    }
                    if (value.includes('size ')) {
                        value = value.replace("size ", "");
                        size = size + ', <span style="white-space: nowrap;">' + value + '</span>';
                    }
                    if (value.includes('clr')) {
                        value = value.replace("clr-", "");
                        value = value.split("-");
                        clr = clr + ', <span style="white-space: nowrap;">' + value[2] + '</span>';
                    }
                    if (value.includes('clf')) {
                        value = value.replace("clf-", "");
                        value = value.split("-");
                        clf = clf + ', ' + value[2];
                    }
                    if (value.includes('feat-')) {
                        value = value.replace("feat-", "");
                        value = value.split("-");
                        feat = feat + ', ' + value;
                    }
                    if (value.includes('shp-')) {
                        value = value.replace("shp-", "");
                        value = value.split("-");
                        shp = shp + ', ' + value;
                    }
                    if (value.includes('material-')) {
                        value = value.replace("material-", "");
                        value = value.split("-");
                        matrl = matrl + ', ' + value;
                    }
                    if (value.includes('cond-')) {
                        value = value.replace("cond-", "");
                        value = value.split("-");
                        cond = cond + ', ' + value;
                    }
                    if (value.includes('chairtype-')) {
                        value = value.replace("chairtype-", "");
                        value = value.split("-");
                        chairtype = chairtype + ', ' + value;
                    }
                    if (value.includes('categ-')) {
                        value = value.replace("categ-", "");
                        value = value.split("-");
                        categ = categ + ', ' + value;
                    }
                    if (value.includes('serpentinemodel-')) {
                        value = value.replace("serpentinemodel-", "");
                        value = value.split("-");
                        serpentinemodel = serpentinemodel + ', ' + value;
                    }
                    if (value.includes('serpentinestyle-')) {
                        value = value.replace("serpentinestyle-", "");
                        value = value.split("-");
                        serpentinestyle = serpentinestyle + ', ' + value;
                    }
                    if (value.includes('CocktailTableStyle-')) {
                        value = value.replace("CocktailTableStyle-", "");
                        value = value.split("-");
                        CocktailTableStyle = CocktailTableStyle + ', ' + value;
                    }
                    if (value.includes('DrumCoverSize-')) {
                        value = value.replace("DrumCoverSize-", "");
                        value = value.split("-");
                        DrumCoverSize = DrumCoverSize + ', ' + value;
                    }
                    if (value.includes('TrashCanCoverSize-')) {
                        value = value.replace("TrashCanCoverSize-", "");
                        value = value.split("-");
                        TrashCanCoverSize = TrashCanCoverSize + ', ' + value;
                    }
                    if (value.includes('RunnerStyle-')) {
                        value = value.replace("RunnerStyle-", "");
                        value = value.split("-");
                        RunnerStyle = RunnerStyle + ', ' + value;
                    }
                    if (value.includes('BurlapStyle-')) {
                        value = value.replace("BurlapStyle-", "");
                        value = value.split("-");
                        BurlapStyle = BurlapStyle + ', ' + value;
                    }
                    if (value.includes('printstyle-')) {
                        value = value.replace("printstyle-", "");
                        value = value.split("-");
                        printstyle = printstyle + ', ' + value;
                    }
                    if (value.includes('prodtime-')) {
                        value = value.replace("prodtime-", "");
                        value = value.split("-");
                        prodtime = prodtime + ', ' + value;
                    }
                    if (value.includes('sailshp-')) {
                        value = value.replace("sailshp-", "");
                        value = value.split("-");
                        sailshp = sailshp + ', ' + value;
                    }
                    if (value.includes('sailpoint-')) {
                        value = value.replace("sailpoint-", "");
                        value = value.split("-");
                        sailpoint = sailpoint + ', ' + value;
                    }
                }
            });

            $('section.apd-content').each(function(i, obj) {
                if ($(this).text().includes("NameDetails")) {
                    var sku = $('#sku').text().split("-");
                    sku.pop();
                    sku = sku.join('-');

                    $(this).find('figure>div>table>tbody').append('<tr><td>SKU</td><td>' + sku + '</td></tr>');
                    if (size != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Size</td><td>' + size.substring(1) + '</td></tr>');
                    }
                    if (fab != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Fabric</td><td>' + fab.substring(1) + '</td></tr>');
                    }
                    if (pat != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Pattern</td><td>' + pat.substring(1) + '</td></tr>');
                    }
                    if (clr != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Color</td><td>' + clr.substring(1) + '</td></tr>');
                    }
                    if (clf != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Color Family</td><td>' + clf.substring(1) + '</td></tr>');
                    }
                    if (shp != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Shape</td><td>' + shp.substring(1) + '</td></tr>');
                    }
                    if (feat != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Feature</td><td>' + feat.substring(1) + '</td></tr>');
                    }
                    if (matrl != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Material</td><td>' + matrl.substring(1) + '</td></tr>');
                    }
                    if (cond != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Condition</td><td>' + cond.substring(1) + '</td></tr>');
                    }
                    if (chairtype != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Chair Type</td><td>' + chairtype.substring(1) + '</td></tr>');
                    }
                    if (categ != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Category</td><td>' + categ.substring(1) + '</td></tr>');
                    }
                    if (serpentinemodel != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Serpentine Model</td><td>' + serpentinemodel.substring(1) + '</td></tr>');
                    }
                    if (serpentinestyle != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Serpentine Style</td><td>' + serpentinestyle.substring(1) + '</td></tr>');
                    }
                    if (CocktailTableStyle != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Cocktail Table Style</td><td>' + CocktailTableStyle.substring(1) + '</td></tr>');
                    }
                    if (DrumCoverSize != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Drum Cover Size</td><td>' + DrumCoverSize.substring(1) + '</td></tr>');
                    }
                    if (TrashCanCoverSize != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Trashcan Cover Size</td><td>' + TrashCanCoverSize.substring(1) + '</td></tr>');
                    }
                    if (RunnerStyle != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Runner Style</td><td>' + RunnerStyle.substring(1) + '</td></tr>');
                    }
                    if (BurlapStyle != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Burlap Style</td><td>' + BurlapStyle.substring(1) + '</td></tr>');
                    }
                    if (printstyle != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Print Style</td><td>' + printstyle.substring(1) + '</td></tr>');
                    }
               
                    if (prodtime != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Production Time</td><td>' + prodtime.substring(1) + '</td></tr>');
                    }
                    if (sailshp != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Sail Shape</td><td>' + sailshp.substring(1) + '</td></tr>');
                    }
                    if (sailpoint != "") {
                        $(this).find('figure>div>table>tbody').append('<tr><td>Sail Point</td><td>' + sailpoint.substring(1) + '</td></tr>');
                    }
                }
            });
        }
    }, 5000);

});


/* ---- change image based on diameter and height options by APO ------*/
 $(document).on("change", '.tbl-diameter-cls input:radio, .tbl-height-cls input:radio', function() {
   $('#loader').show(); 
   if(($('.tbl-diameter-cls').find( ".mw-accumulated-title" ).text().trim() != "Other" && $('.tbl-diameter-cls').find( ".mw-accumulated-title" ).text().trim().length != 0 )
	&& ($('.tbl-height-cls').find( ".mw-accumulated-title" ).text().trim() != "Other" && $('.tbl-height-cls').find( ".mw-accumulated-title" ).text().trim().length != 0)){
     let image_diameter=$('.tbl-diameter-cls').find( ".mw-accumulated-title" ).text().split('"')[0];   
     let image_height=$('.tbl-height-cls').find( ".mw-accumulated-title" ).text().split('"')[0]; 
   
     fetch('/apps/acts?requestType=roundSizePicture&diameter='+image_diameter+'&height='+image_height).then(response => response.json()).then(function(data) {  
      $("html, body").animate({
                    scrollTop: 0
                }, "slow");
      if(data.error==false){
            $('.gravizoomImg:nth(0)').attr('src','data:image/jpg;base64,'+data.url);
     
        $('.rondell-item-image:nth(0)').attr('src','data:image/jpg;base64,'+data.url);

      $('#lightgallery>li:nth(0)>a>img').attr('src','data:image/jpg;base64,'+data.url);
  $('#lightgallery>li:nth(0)').attr('data-src','data:image/jpg;base64,'+data.url);
  $('.rondel-item:nth(0)').attr('href', 'data:image/jpg;base64,'+data.url);
    if($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused')==false){
	$(".rondell-item-crop:nth(0)").trigger( "click" );
      }     
      }else{
      $('.gravizoomImg:nth(0)').attr('src',$('.rondell-item:nth(0)').attr('href'));
     $('ul#lightgallery>li:nth(0)>a>img').attr('src', $('.rondell-item:nth(0)').attr('href'));
  $('ul#lightgallery>li:nth(0)').attr('data-src', $('.rondell-item:nth(0)').attr('href'));
            $('.rondell-item-image:nth(0)').attr('src',$('.rondell-item:nth(0)').attr('href'));
  $('.rondel-item:nth(0)').attr('href',$('.rondell-item:nth(0)').attr('href'));
      if($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused')==false){
	$(".rondell-item-crop:nth(0)").trigger( "click" );
      }
       
      }
    $('#loader').hide();
      
        });
     
   }else{
      $('.gravizoomImg:nth(0)').attr('src',$('.rondell-item:nth(0)').attr('href'));
     $('ul#lightgallery>li:nth(0)>a>img').attr('src', $('.rondell-item:nth(0)').attr('href'));
  $('ul#lightgallery>li:nth(0)').attr('data-src', $('.rondell-item:nth(0)').attr('href'));
            $('.rondell-item-image:nth(0)').attr('src',$('.rondell-item:nth(0)').attr('href'));
  $('.rondel-item:nth(0)').attr('href',$('.rondell-item:nth(0)').attr('href'));
      if($(".rondell-item-crop:nth(0)").parent().hasClass('rondell-item-focused')==false){
	$(".rondell-item-crop:nth(0)").trigger( "click" );
      }
     $('#loader').hide();
      }
   
 });

/*------ Terms and COnditions POP UP -----*/
function showTandC(){
        //name="customer[tags]"
      $('#tandCModal').fadeIn(500);
  		return true;
     
  }
  function closeModal()
  {
    
    				
	$('.modals').fadeOut(500);
	
  }

/*------ T.\erms and COnditions POP UP -----*/

$(document).on('click', '.btn-size-popup', function(){
  let response=true;
  //pantone required color
 
  if($("#product-pantone-color").length)
  {
    if($("#product-pantone-color").val() == "")
    {
      $(".product-pantone-color-error").removeClass("hidden");
      return false;
    }
  }

 //size
  if($("#size-popup-modal-btn").attr("check") == "true"){
  $(".product-form__item").find("label").each(function() {
    if ($(this).text().trim() == "Size") {
      let selectedVal=$(this).next().find(":selected").text();
      selectedVal = selectedVal.replaceAll(" ","");
	  selectedVal = selectedVal.replaceAll('"',"");
      selectedVal = selectedVal.replaceAll('-',"");
      if(selectedVal.trim() == "10x10Cocktail")
      {
        	  $("#size-popup-modal-btn").attr("check", true);
              $('#size-popup-modal').fadeIn(500);
        $('html, body').animate({
        scrollTop: $("#size-popup-modal").offset().top
    }, 1000);

	response=false;

      }
    }
   
});
    
  }
//   else
//   {
//     // update profile for item

//   }
  return response;

});

function triggerAddToCart()
{
  $("#size-popup-modal-btn").attr("check", false);
              $('#size-popup-modal').fadeOut(500);
  return true;
}

// function waitForElement(elementPath, callBack){
//   window.setTimeout(function(){
//     console.log("trying")
// //     if($(elementPath).length ){
//       if($("covet-pics-widget")[0].shadowRoot != null){
//         console.log($("covet-pics-gallery-grid.hydrated"))
//         var sr = $("covet-pics-widget")[0].shadowRoot;
//         var sr2 = $("covet-pics-widget").shadowRoot;
//          childNodes = sr.childNodes;
//         var btnsArr = Array.prototype.slice.call(childNodes);
//         $(childNodes).each(function(){
//         alert(1);})
       
//         console.log(btnsArr);
// //   console.log(sr);
// //         console.log(sr2);
        
//          console.log($(sr).contents());
// //          console.log(el.find(".filters").html());
// //          console.log(el.find(".filters").val());
// //         console.log($(sr));
// //         console.log(el);
//         $(sr).find("button [data-filter='egyptian']").click()
//       callBack(elementPath, $(elementPath));
//     }else{
//       waitForElement(elementPath, callBack);
//     }
//   },500)
// }

// waitForElement("covet-pics-widget",function(){
//     console.log("done");
// });



document.addEventListener('galleryReady:covetPics', function(e) {
  const myDiv = document.querySelectorAll('.grid-item');
divs.forEach(div => {
  div.addEventListener('click', function(event) {
    event.stopPropagation();
    event.preventDefault();
  });
  div.classList.add('disabled');
});

//   alert("hello")
  console.log('Gallery Id: ', e.detail.galleryId);
  console.log('Gallery items count: ', e.detail.itemsCount);
  console.log('Gallery element', e.detail.el);
  let locationHash=$(location).attr('hash')
//   alert(locationHash);
  //$(e.detail.el).find(".filters").hide(); // testing if filter style applies after hiding the filter div - worked
  if(locationHash != '')
  {
    locationHash=locationHash.replaceAll('_', ' ')
    locationHash=locationHash.replaceAll('#', '')
    $(e.detail.el).find("button[data-filter='"+locationHash+"']").click()
  }
  $(e.detail.el).find("button").on("click", function(){
    let filter=$(this).attr('data-filter');
    if(typeof filter == "undefined")
    {
      //ALL
      window.location.href=window.location.href.split('#')[0]
      

    }
    else
    {  filter=filter.replaceAll(' ', '_')
    window.location.hash = filter;}
      
  
});
});

$(".download-rental-file").click(function(e) {
  e.preventDefault();
  let href=$(this).attr("href");
  
  fetch(href, {
    method: 'GET'
}).then(resp => resp.blob())
    .then(blob => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.style.display = 'none';
        a.href = url;
        a.download = "Rental Agreement"; // the filename you want
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
    })

})


window.addEventListener('load', function () {
    console.log('ReadMoreSection: window.load event fired');
    const container = document.querySelector(".read-more-section");
    if (container) {
        console.log('ReadMoreSection: Code running');
        const button = document.createElement("div");
        button.className = "read-more-btn";
        button.textContent = "↓ Read More ↓";

        // check if for some reason the overlay already exists
        var overlay = document.querySelector(".read-more-overlay");
        if (!overlay) {
            overlay = document.createElement("div");
            overlay.className = "read-more-overlay";
            container.appendChild(overlay);
        }
    
        container.insertAdjacentElement("afterend", button);
    
        button.addEventListener("click", () => {
            container.classList.toggle("read-more-section");
            overlay.classList.toggle("read-more-overlay");
            button.textContent = button.textContent === "↓ Read More ↓" ? "↑ Read Less ↑" : "↓ Read More ↓";
        });
    } else {
        console.log('ReadMoreSection: No container found');
        return;
    }
  
});



